<template>
  <AdsForm />
</template>

<script>
import AdsForm from '../components/AdsForm.vue'

export default {
  components: {
    AdsForm,
  },
}
</script>
